import { buildUniqueSkillRows, countSkillsLosingRulesWithTrade } from "./build-skill-map-trade-rows"

/**
 * How many skills lose conditional routing rules when a trade is removed: those with a rule
 * sending work to it, and its own skills with any rules, since a skill whose default trade
 * goes loses all of them. The server drops those rules, so the removal warning names them; a
 * trade with no skills of its own can still be busy this way.
 *
 * Skills are de-duplicated the same way the skill routing view does it, so a skill with
 * several lines (or several rules to the same trade) counts once.
 *
 * @param {object[]} lines SkillMapLine records
 * @param {string} tradeId
 * @returns {number}
 */
export function countConditionalRulesForTrade(lines, tradeId) {
    return countSkillsLosingRulesWithTrade(buildUniqueSkillRows(lines || []), tradeId)
}
